<hk-app-frame>
  <ng-container hkAppContentRaw>
    <div class="flex flex-1 flex-col gap-4 bg-hk_gray-100 md:flex-row">
      <hk-layout-container class="flex min-h-[400px] flex-1 md:grow-0 md:basis-1/2 xl:basis-2/3">
        <iframe [src]="statusPageSafeResourceUrl" allowfullscreen class="h-full w-full overflow-y-hidden"></iframe>
      </hk-layout-container>

      <div class="flex flex-1 flex-col gap-4">
        <hk-overview-card [titleText]="'overview.newsTitle'">
          <hk-news></hk-news>
        </hk-overview-card>
        <hk-overview-card [titleText]="'overview.contactTitle'">
          <hk-emergency-contact></hk-emergency-contact>
        </hk-overview-card>
      </div>
    </div>
  </ng-container>
</hk-app-frame>
